import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchPatientData = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);
  return response.data;
};

export const fetchAldreteScore = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_alderete_score/${uhidNo}`);
  return response.data;
};

export const saveAldreteScore = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/insert_alderete_score`, data);
  return response.data;
};

export const updateAldreteScore = async (uhidNo, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_alderete_score/${uhidNo}`, data);
  return response.data;
};

export const generateAldreteShareToken = async (uhidNo) => {
  const response = await axios.post(`${API_BASE_URL}/generate_for_alderete_api_share_token/${uhidNo}`);
  return response.data;
};
